import { localisedValue } from "utils"

export const leadsFilterCategoriesTransformer = response => {
  const hierarchicalCategoryTransformer = categories =>
    categories?.map(cat => ({
      title: localisedValue({ object: cat, key: "title" }),
      value: cat.id?.toString(),
      key: cat.id?.toString(),
      ...(cat?.children?.length ? { children: hierarchicalCategoryTransformer(cat.children) } : {}),
    }))
  return hierarchicalCategoryTransformer(response?.[0]?.children ?? [])
}
